import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["urlInput", "selector"]

  connect() {
    this.baseUrl = this.urlInputTarget.value
  }

  updateUrl() {
    const selectedValue = this.selectorTarget.value
    let newUrl = this.baseUrl

    if (selectedValue) {
      const urlParts = newUrl.split('?')
      const baseUrlPart = urlParts[0]
      const queryParams = urlParts[1] || ''
      
      if (queryParams) {
        newUrl = `${baseUrlPart}?${queryParams}&upsell_block=${selectedValue}`
      } else {
        newUrl = `${baseUrlPart}?upsell_block=${selectedValue}`
      }
    }

    this.urlInputTarget.value = newUrl
  }
}
